export enum PreviewLayoutEnum {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

export type PreviewLayout =
  | PreviewLayoutEnum.MOBILE
  | PreviewLayoutEnum.DESKTOP;
